mutation signInMutation($input: SignInInput!) {
  signIn(input: $input) {
    user {
      id
      preferredLanguage
      contentLanguages
    }
    authentificationToken
  }
}